module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-1.380b9df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-1.png
// module id = 189
// module chunks = 0